import React from "react";

const SVGExternalArrow: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M13.9303 10.562L21.7959 10.331L22.0269 18.1965"
      stroke="#323B49"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.105 21.6687L21.6889 10.4443"
      stroke="#323B49"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGExternalArrow;
